import Avatar from '@material-ui/core/Avatar';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Container from '@material-ui/core/Container';
import Copyright from '../componentes/copyright'
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import logo from './logo.png';
import {authConfig} from '../auth/config';
import React,{ useCallback,useContext} from 'react';
import {withRouter,Redirect, useHistory} from 'react-router-dom';
import { useForm } from "react-hook-form";
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';



const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexGrow: 1,
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.primary.main,
    display: 'flex',
    
    flexGrow: 1,
  },
  
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),

   

  },
  root: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
  },
  logo: {
    width:'100px',
    height:'100px',
    
    
  },

  cabeca: {
    marginLeft: theme.spacing(2),
    
    
  },
}));


    export const resetPassword = withRouter(({history}) => {

      const classes = useStyles();
      const handlerReset = useCallback(
       
      async (event) => {

       
        var email = document.getElementById('email').value;
        
        
         try{
              authConfig.auth().sendPasswordResetEmail(email);
  
                 
                      alert('Foi enviado um e-mail de redefinição de senha para ' + email);
                              
                   
                  
  
              history.push('/'); 
            }catch(error) {
              // Handle Errors here.
              var errorCode = error.code;
              var errorMessage = error.message;
       
                       alert(errorMessage);
              
       
            }
          
        },
        
       // [history],
      )

      function handlerVoltar(){
       
        
    
                history.push('/'); 
              
          
          
      }
       
      

      function onSubmit() {
    
      }
    

     
      document.title = 'Frota UFSM - Esqueceu a senha'
      document.logo=''
      
        
      
 

  return (

 
      
    <Container component="main" >
      <CssBaseline />
      
      <div className={classes.root}><AppBar position="static">
        <Toolbar>
        
        <img src={logo} className={classes.logo} alt="logo" />
         
        
        <Typography className = {classes.cabeca} component="h1" variant="h5"  >
          Frota UFSM
        </Typography>
          
        </Toolbar>
      </AppBar></div>
      <Container maxWidth="xs">
      <div className={classes.paper}>
      
      
       <Typography component="h1" variant="h5">
         Preencha com o E-mail Cadastrado
        </Typography>
        <form className={classes.form}  onSubmit={handlerReset} Validate>
          
        
                    
          <TextField
            variant="outlined"
            margin="normal"
            //onChange={ e=>setEmail(e.target.value)}
            required
            type="mail"
            fullWidth
            id="email"
            label="E-mail"
            name="email"
            autoComplete="signInWithEmailAndPassword"
            autoFocus
            
          />
          
          <Grid container>
            <Grid item xs>
            
            </Grid>
            <Grid item xs>
            
            </Grid>
            <Grid item xs>
            <Button
            type="submit"
           
            variant="contained"
            color="primary"
            className={classes.submit}
            onClick={handlerVoltar}
            
          >
            Voltar
          </Button>
            </Grid>
            <Grid item xs>
            <Button
            type="submit"
                     
            variant="contained"
            color="primary"
            className={classes.submit}
          >
            Enviar
          </Button>
            </Grid>
            
          </Grid>
          
        </form>
      </div>
      </Container>
      <Box mt={3}>
        <Copyright />
      </Box>
    </Container>
  );
})

export default resetPassword;